import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import { Post } from '../../../../function/Koneksi';

const ModalPenomoranSurat = ({ data, optionData, setAlert, isOpen, setIsOpen, setStatusRefresh}) => {

	const frmDex = {
		uuid: '',
		nomor: '',
		id_jenis: '',
	}

	const initFormData = {
		kodeSuratDetail: optionData.kodeSuratDetail,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		// console.log(data);
		// console.log(optionData);
		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])

	const changeInputText = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value,
		})
	};

	const simpan = (e) => {
		e.preventDefault();
		setAlert({
			loadingPreview: true
		})

		let bodyRaw = {
			...dt,
			id_jenis: formData.kodeSuratDetail.uuid,
		}

		let psn = "Tambah";
		let resstat = 201;
		let metode = "create";
		bodyRaw.uuid = null;
		
		Post("penomoran-jenis/" + metode, bodyRaw.uuid, bodyRaw,res => {
			console.log('respon simpan')
			console.log(res)
			setFormData({
				...formData,
				status: {
					...formData.status,
					btnForm: false,
					form: false,
				}
			})
			setIsOpen(false)
			if (res.status === resstat) {
				setAlert({
					loadingPreview: false
				})

				const alertData = {
					show: true,
					basicType: "success",
					basicTitle: "Data Penomoran "+formData.kodeSuratDetail.nama_surat,
					pesanAlert: "Berhasil " + psn + " Data",
					successAlert: true,
				}
				setAlert(alertData)
			} else {
				setAlert({
					loadingPreview: false
				})

				const alertData = {
					show: true,
					basicType: "danger",
					basicTitle: "Data Penomoran "+formData.kodeSuratDetail.nama_surat,
					pesanAlert: res.data && res.data.message ? res.data.message :"Gagal " + psn + " Data"
				}
				setAlert(alertData)
			}

			// Refresh list
			setStatusRefresh(true)
		});
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Penomoran {formData.kodeSuratDetail?formData.kodeSuratDetail.nama_surat:''}</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<FormGroup className="row">
						<Label
						className="col-sm-3 col-form-label"
						htmlFor="inputEmail3"
						>
						Nomor Surat{" "}
						</Label>
						<Col sm="9">
							<input
								data-testid="nomor"
								name="nomor"
								className="form-control"
								id="nomor"
								type="text"
								placeholder="Masukkan nomor urut surat"
								defaultValue={dt.nomor}
								required
								onChange={e => changeInputText(e, "nomor")}
							/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							// Tutup modal
							setFormData({
								...formData,
								status: {
									...formData.status,
									form: false,
								}
							})
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalPenomoranSurat;
